<template>
    <div class="container">
        <h2 class="profile-page-title">
            {{ $t('my_study_products') }}
            <span class="profile-page-title__count">({{ userStudyProducts.length }})</span>
        </h2>

        <div class="row">
            <div class="col-12">
                <div class="row justify-content-center">

                    <div class="col-12 col-sm-3 study-list-item"
                         v-for="item in userStudyProducts"
                         :key="item.studyProduct.idstudyproduct">
                        <div class="study-product-logo"
                        >
                            <img :src="item.studyProduct.logo" @click="toStudyProduct(item.studyProduct)">
                            <div class="study-product-name" @click="toStudyProduct(item.studyProduct)">
                                {{ item.studyProduct.name }}
                            </div>
                            <div v-if="item.crmSubscriptions && item.crmSubscriptions.length > 0" class="mt-4">
                                {{ $t('subscription_to') }}: <span class="strong-black">{{ item.crmSubscriptions[item.crmSubscriptions.length-1].end_date | formatDate }}</span>
                            </div>
                            <div>
                                <button
                                        class="btn mt-3 sb-red-prolong-btn red-prolong-btn btn-default"
                                        @click="prolong(item.studyProduct)">
                                    {{ $t('prolong_subscription') }} →
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import userApi from '@/data/UserApi';
    import StudyListItem from "../../Study/StudyListItem";
    import moment from 'moment';

    export default {
        name: 'Browse',

        data() {
            return {
                user: {
                    userCourses: []
                },
                userStudyProducts: [],
            }
        },

        mounted() {
            moment.locale(this.$i18n.locale)
            this.fetchProfile()
            this.fetchStudyProducts()
        },

        methods: {
            fetchProfile() {
                userApi.fetchProfile()
                    .then(response => {
                        this.user = response;
                    });
            },

            fetchStudyProducts() {
                userApi.fetchStudyProducts()
                    .then(response => {
                        this.userStudyProducts = response;
                    });
            },

            toStudyProduct(studyProduct) {
                window.location.href = `/${studyProduct.slug}.html`
                //this.$router.push(`/${studyProduct.slug}`)
            },

            prolong(studyProduct) {
                this.$router.push(`/${studyProduct.slug}/order`)
            }
        },

        filters: {
            formatDate: function (value) {
                return moment(value).format('DD.MM.YYYY')
            }
        },

        components: {
            StudyListItem,
        }
    }
</script>

<style>
    .profile-page-title__count {
        color: #c0c0c0;
        font-size: 1rem;
    }

    .profile-page-title a {
        color: #0493c3;
        border-bottom: 1px solid;
    }

    /* cards */
    .course-card {
        border: 1px solid #d7e0e5;
        border-radius: 6px;
        margin-bottom: 30px;
        padding: 20px;
        position: relative;
    }

    .course-card-title {
        display: block;
        font-family: 'Manrope Bold', 'Open Sans', sans-serif;
        line-height: 1.4;
    }

    .course-card-title__language {
        color: #c0c0c0;
    }

    .course-card__button {
        border-radius: 18px;
        color: #fff !important;
        font-family: 'Manrope Bold', 'Open Sans', sans-serif;
    }

    .course-card__button--red {
        background-color: #f15a21;
    }

    .course-card__description,
    .course-card__description p {
        color: #999 !important;
        line-height: normal;
    }

    .red-prolong-btn {
        background-color: #d7e1e5;
        border-color: #d7e1e5;
        border-radius: 30px;
        color: #231c37;
        font-family: "Manrope Bold";
        width: 254px;
        font-size: 16px;
        line-height: 16px;
        padding-left: 0;
        padding-right: 0;
    }

    .red-prolong-btn:disabled, .red-prolong-btn.btn-default:disabled:hover {
        background-color: #d7e1e5;
        border-color: #d7e1e5;
        opacity: 0.8;
        color: rgba(35, 28, 55, 0.55);
        text-shadow: none;
    }

    .red-prolong-btn, .red-prolong-btn.btn-default:hover {
        background-color: #de0035;
        border-color: #de0035;
        color: white;
        text-shadow: 1px 1px 2px #97191e;
    }
</style>
